// Features: M004-F0807 (WebUI #270, milestone M4a: the calendar update section mounted on the Ledger queue, still gated off)
// Tests: T-M004-0467 (see CalendarUpdateSection.test.js beside this file), T-M004-0470 (browser gate-off proof).
//
// Composes the read-only badge, the list and the review view. Renders NOTHING, and makes NO request, unless the view gate is on
// AND the user can manage the Ledger (ledger_manage). The gate is CALENDAR_UPDATE_VIEW_ENABLED, false in this release.
import React, { useState } from 'react';
import { calendarUpdateApi } from '../../../services/calendarUpdateApi';
import { CALENDAR_UPDATE_VIEW_ENABLED } from './calendarUpdateModel';
import CalendarUpdateBadge from './CalendarUpdateBadge';
import CalendarUpdateList from './CalendarUpdateList';
import CalendarUpdateReview from './CalendarUpdateReview';

export default function CalendarUpdateSection({
  orgId, canManage, viewEnabled = CALENDAR_UPDATE_VIEW_ENABLED,
}) {
  const [selected, setSelected] = useState(null);
  if (!viewEnabled || !canManage) return null;
  return (
    <section className="ledger-account-section ledger-queue-section calendar-update-section" data-testid="calendar-update-section" aria-label="Calendar updates">
      <h3 className="calendar-update-heading">
        <CalendarUpdateBadge orgId={orgId} canManage={canManage} viewEnabled={viewEnabled} api={calendarUpdateApi} />
      </h3>
      <CalendarUpdateList orgId={orgId} canManage={canManage} viewEnabled={viewEnabled} api={calendarUpdateApi} onOpen={setSelected} />
      {selected ? (
        <CalendarUpdateReview
          proposal={selected}
          proposalId={selected.proposal_id}
          orgId={orgId}
          canManage={canManage}
          viewEnabled={viewEnabled}
          api={calendarUpdateApi}
          onClose={() => setSelected(null)}
        />
      ) : null}
    </section>
  );
}
